import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import introImage from "../assets/Blue-intro.jpg";
import juniorImage from "../assets/AssociateEntryLevelLive.jpg";
import seniorImage from "../assets/ConsultantMidLevel.jpg";

import certificationIcon from "../assets/certification.png";
import careerGuidanceIcon from "../assets/career-guidane.png";
import interviewIcon from "../assets/job-interview.png";

import sqlInjectionImage from "../assets/blog_images/sqlInjection/sql_injection1.jpg";
import brokenAccessImage from "../assets/blog_images/BrokenAccessControllAuthentication/brokenThumbnail.png";
import sessionManagementImage from "../assets/blog_images/sessionManagement/session1.png";

const SUPPORT_WHATSAPP_NUMBER = "919080432374";
const SUPPORT_MESSAGE = "Hi, I am looking for Cyber Security Training";

const courseCards = [
  {
    title: "AppSec/VAPT Junior Penetration Tester",
    level: "Entry-Level",
    route: "/junior-penetration-tester",
    image: juniorImage,
    accent: "blue",
    description:
      "Build a strong foundation in cybersecurity, web application security, network fundamentals, OWASP Top 10, Burp Suite, Nmap, Metasploit, and practical VAPT workflows.",
    highlights: ["Live", "Weekday", "English", "Beginner Friendly"],
    outcomes: [
      "Network & Web VAPT fundamentals",
      "Hands-on labs and assignments",
      "Mock interviews and career support",
    ],
    badgeClass: "bg-blue-100 text-blue-700 border-blue-200",
    buttonClass:
      "bg-gradient-to-r from-blue-700 to-cyan-500 shadow-blue-700/20 hover:scale-[1.03]",
    glowClass: "from-blue-500/25 via-cyan-400/20 to-transparent",
  },
  {
    title: "AppSec/VAPT Senior Penetration Tester",
    level: "Mid-Level / Advanced",
    route: "/senior-penetration-tester",
    image: seniorImage,
    accent: "red",
    description:
      "Move into advanced application security, API penetration testing, Android application testing, thick client testing, CTF practice, and real-world security assessment workflows.",
    highlights: ["Live", "Advanced VAPT", "API Security", "Cloud Labs"],
    outcomes: [
      "API, Android and Thick Client PT",
      "Advanced exploitation workflows",
      "Real-world assessment reporting",
    ],
    badgeClass: "bg-red-100 text-red-700 border-red-200",
    buttonClass:
      "bg-gradient-to-r from-red-600 via-purple-700 to-blue-700 shadow-red-700/20 hover:scale-[1.03]",
    glowClass: "from-red-500/25 via-purple-500/20 to-transparent",
  },
];

const benefits = [
  {
    title: "Learn From Industry Experts",
    description:
      "Get trained by experienced cybersecurity professionals who understand real assessment workflows, reporting, and client expectations.",
    icon: "🛡️",
  },
  {
    title: "Hands-On Training",
    description:
      "Go beyond theory with practical labs, guided exploitation, real tools, and scenario-based learning.",
    icon: "🧪",
  },
  {
    title: "Recognized Certifications",
    description:
      "Earn completion credentials that support your cybersecurity learning journey and strengthen your profile.",
    iconImage: certificationIcon,
  },
  {
    title: "Community Support",
    description:
      "Be part of a focused cybersecurity learning community where you can ask, practice, revise, and grow.",
    icon: "👥",
  },
  {
    title: "Career Guidance",
    description:
      "Get support for resume building, LinkedIn profile improvement, role mapping, and career direction.",
    iconImage: careerGuidanceIcon,
  },
  {
    title: "Real-World Labs",
    description:
      "Practice in lab environments designed to simulate vulnerable apps, APIs, networks, and security testing scenarios.",
    icon: "🖥️",
  },
  {
    title: "Mock Interviews",
    description:
      "Prepare for job opportunities with interview simulations focused on web, mobile, API, and VAPT roles.",
    iconImage: interviewIcon,
  },
  {
    title: "CTF Challenges & Quizzes",
    description:
      "Sharpen your practical thinking with CTF tasks, quizzes, and skill-based challenges.",
    icon: "🚩",
  },
];

const blogCards = [
  {
    title: "Understanding SQL Injection: A Web Security Threat",
    category: "Web Application Security",
    date: "May 03, 2025",
    readTime: "7 min read",
    image: sqlInjectionImage,
    description:
      "SQL Injection is a critical security flaw that allows attackers to manipulate SQL queries, risking data breaches or full database control.",
  },
  {
    title: "Broken Access Control & Auth: A Security Breakdown",
    category: "OWASP Top 10",
    date: "May 02, 2025",
    readTime: "5 min read",
    image: brokenAccessImage,
    description:
      "Broken Access Control and Authentication vulnerabilities allow unauthorized users to access restricted data or actions.",
  },
  {
    title: "Secure Session Management: Best Practices & Techniques",
    category: "Web Application Security",
    date: "Apr 28, 2025",
    readTime: "5 min read",
    image: sessionManagementImage,
    description:
      "Learn techniques to prevent session-related threats such as session hijacking, fixation, and weak cookie handling.",
  },
];

function Home() {
  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    document.title = "Home | Practical Infosec";

   function handleScroll() {
    setShowBackToTop(window.scrollY > 300);
  }

  window.addEventListener("scroll", handleScroll);
  handleScroll();

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };

 
  }, []);

  function scrollToCourses() {
    document.getElementById("top-courses")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  function toggleWhatsAppModal(event) {
  if (event) {
    event.stopPropagation();
  }

  setWhatsappOpen((prev) => !prev);
}

  function openWhatsAppChat() {
    const encodedMessage = encodeURIComponent(SUPPORT_MESSAGE);
    const whatsappUrl = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodedMessage}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  }

  function openWhatsAppAppFallback() {
    const encodedMessage = encodeURIComponent(SUPPORT_MESSAGE);
    const deepLink = `whatsapp://send?phone=${SUPPORT_WHATSAPP_NUMBER}&text=${encodedMessage}`;
    const webLink = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodedMessage}`;

    window.location.href = deepLink;

    setTimeout(() => {
      window.open(webLink, "_blank", "noopener,noreferrer");
    }, 700);
  }

  return (
    <main className="overflow-hidden bg-white">
      {/* HERO */}
<section className="relative px-4 overflow-hidden py-14 bg-slate-950 md:px-20 md:py-20">
  {/* Background */}
  <div className="absolute inset-0">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(37,99,235,0.35),transparent_35%),radial-gradient(circle_at_bottom_right,rgba(14,165,233,0.25),transparent_35%),radial-gradient(circle_at_center,rgba(124,58,237,0.18),transparent_42%)]"></div>

    <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.045)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.045)_1px,transparent_1px)] bg-[size:44px_44px] opacity-30"></div>

    <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black/70 to-transparent"></div>
  </div>

  <div className="relative z-10 grid items-center gap-12 mx-auto max-w-7xl lg:grid-cols-[1fr_1fr]">
    {/* Left Content */}
    <div>
      <span className="inline-flex items-center gap-2 px-4 py-2 text-xs font-black tracking-widest uppercase border rounded-full text-cyan-300 bg-white/10 border-white/15 backdrop-blur">
        <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
        Practical Cybersecurity Learning Platform
      </span>

      <h1 className="mt-6 text-4xl font-black leading-tight tracking-tight text-white md:text-6xl">
        Build Your Career in{" "}
        <span className="text-transparent bg-gradient-to-r from-cyan-300 via-blue-300 to-purple-300 bg-clip-text">
          Application Security & VAPT
        </span>
      </h1>

      <p className="max-w-3xl mt-6 text-lg font-semibold leading-8 text-slate-300">
        Learn cybersecurity through live classes, practical labs, real-world
        tools, cloud lab access, mentor guidance, mock interviews, and
        job-focused training designed for aspiring security professionals.
      </p>

      <div className="flex flex-col gap-4 mt-8 sm:flex-row">
        <button
          type="button"
          onClick={scrollToCourses}
          className="inline-flex items-center justify-center px-8 py-4 text-base font-black text-white transition shadow-xl cursor-pointer rounded-xl bg-gradient-to-r from-blue-700 to-cyan-500 shadow-blue-700/20 hover:scale-105 hover:shadow-2xl"
        >
          Explore Live Batches →
        </button>

        <Link
          to="/senior-penetration-tester"
          className="inline-flex items-center justify-center px-8 py-4 text-base font-black text-white transition border rounded-xl border-white/20 bg-white/10 backdrop-blur hover:bg-white hover:text-slate-950"
        >
          View Senior Program
        </Link>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 gap-4 mt-10 sm:grid-cols-4">
        <div className="p-4 border rounded-2xl bg-white/10 border-white/15 backdrop-blur">
          <p className="text-2xl font-black text-white">Live</p>
          <p className="mt-1 text-xs font-bold text-slate-300">
            Instructor-Led
          </p>
        </div>

        <div className="p-4 border rounded-2xl bg-white/10 border-white/15 backdrop-blur">
          <p className="text-2xl font-black text-white">Labs</p>
          <p className="mt-1 text-xs font-bold text-slate-300">
            Practical Access
          </p>
        </div>

        <div className="p-4 border rounded-2xl bg-white/10 border-white/15 backdrop-blur">
          <p className="text-2xl font-black text-white">2 Years</p>
          <p className="mt-1 text-xs font-bold text-slate-300">
            Recordings
          </p>
        </div>

        <div className="p-4 border rounded-2xl bg-white/10 border-white/15 backdrop-blur">
          <p className="text-2xl font-black text-white">Career</p>
          <p className="mt-1 text-xs font-bold text-slate-300">
            Guidance
          </p>
        </div>
      </div>
    </div>

    {/* Right Image - Full Image Visible */}
    <div className="relative">
      <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-r from-blue-500/40 via-cyan-400/30 to-purple-500/30 blur-2xl"></div>

      <div className="relative overflow-hidden border shadow-2xl rounded-[2rem] border-white/15 bg-white/10 backdrop-blur">
        {/* Image Area */}
        <div className="p-3 bg-slate-950/70">
          <img
            src={introImage}
            alt="Cybersecurity learning platform"
            className="object-contain w-full h-auto rounded-[1.5rem]"
          />
        </div>

        {/* Program Links - Not covering the image */}
        <div className="p-5 border-t bg-slate-950/95 border-white/10">
          <p className="text-xs font-black tracking-widest uppercase text-cyan-300">
            Live Programs Open
          </p>

          <div className="grid grid-cols-1 gap-3 mt-3 sm:grid-cols-2">
            <Link
              to="/junior-penetration-tester"
              className="p-3 transition border group rounded-xl bg-white/10 border-white/10 hover:bg-white hover:text-slate-950"
            >
              <p className="text-sm font-black text-white group-hover:text-slate-950">
                Junior Penetration Tester
              </p>
            </Link>

            <Link
              to="/senior-penetration-tester"
              className="p-3 transition border group rounded-xl bg-white/10 border-white/10 hover:bg-white hover:text-slate-950"
            >
              <p className="text-sm font-black text-white group-hover:text-slate-950">
                Senior Penetration Tester
              </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* TOP COURSES */}
      <section
        id="top-courses"
        className="relative px-4 py-10 overflow-hidden bg-gradient-to-br from-slate-50 via-white to-blue-50 md:px-20"
      >
        <div className="absolute top-0 right-0 rounded-full w-96 h-96 bg-blue-200/40 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 rounded-full w-96 h-96 bg-cyan-200/30 blur-3xl"></div>

        <div className="relative z-10 mx-auto max-w-7xl">
          <div className="max-w-5xl mx-auto mb-12 text-center">
            <span className="inline-flex items-center gap-2 px-5 py-2 text-xs font-black tracking-widest text-blue-700 uppercase bg-blue-100 border border-blue-200 rounded-full shadow-sm">
              <span className="w-2 h-2 bg-blue-700 rounded-full animate-pulse"></span>
              Upcoming Live Batches
            </span>

            <h2 className="mt-5 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
              Choose Your{" "}
              <span className="text-blue-700">Cybersecurity Program</span>
            </h2>

            <p className="max-w-4xl mx-auto mt-5 text-lg font-semibold leading-8 text-slate-600">
              Kickstart or elevate your cybersecurity journey with expert-led
              live batches, practical tools, real-world labs, and career-focused
              mentorship.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            {courseCards.map((course) => (
              <div
                key={course.title}
                className="relative transition group hover:-translate-y-2"
              >
                <div
                  className={`absolute -inset-3 rounded-[2rem] bg-gradient-to-r ${course.glowClass} opacity-0 blur-2xl transition group-hover:opacity-100`}
                ></div>

                <div className="relative overflow-hidden bg-white border shadow-2xl rounded-[2rem] border-slate-200">
                  <div className="relative">
                    <img
                      src={course.image}
                      alt={course.title}
                      className="object-cover w-full h-64"
                    />

                    <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-slate-950/20 to-transparent"></div>

                    <div className="absolute left-5 right-5 bottom-5">
                      <div className="flex flex-wrap items-center justify-between gap-3">
                        <span
                          className={`inline-flex items-center px-4 py-2 text-xs font-black border rounded-full ${course.badgeClass}`}
                        >
                          {course.level}
                        </span>

                        <span className="inline-flex items-center gap-2 px-4 py-2 text-xs font-black text-green-300 border rounded-full bg-green-500/10 border-green-400/30 backdrop-blur">
                          <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                          Enrollment Open
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="p-6 md:p-7">
                    <h3 className="text-2xl font-black leading-tight text-slate-950">
                      {course.title}
                    </h3>

                    <p className="mt-4 text-base font-semibold leading-7 text-slate-600">
                      {course.description}
                    </p>

                    <div className="flex flex-wrap gap-2 mt-5">
                      {course.highlights.map((item) => (
                        <span
                          key={item}
                          className="px-3 py-1 text-xs font-black border rounded-full text-slate-700 bg-slate-50 border-slate-200"
                        >
                          {item}
                        </span>
                      ))}
                    </div>

                    <div className="grid grid-cols-1 gap-3 mt-6">
                      {course.outcomes.map((item) => (
                        <div key={item} className="flex items-center gap-3">
                          <span className="flex items-center justify-center w-6 h-6 text-xs font-black text-white bg-green-600 rounded-full">
                            ✓
                          </span>
                          <p className="text-sm font-bold text-slate-700">
                            {item}
                          </p>
                        </div>
                      ))}
                    </div>

                    <div className="grid grid-cols-1 gap-3 mt-7 sm:grid-cols-2">
                      <Link
                        to={course.route}
                        className={`inline-flex items-center justify-center px-6 py-4 text-base font-black text-white transition shadow-xl rounded-2xl ${course.buttonClass}`}
                      >
                        View Details →
                      </Link>

                      <Link
                        to={`${course.route}#demoRegistration`}
                        className="inline-flex items-center justify-center px-6 py-4 text-base font-black transition border rounded-2xl text-slate-800 border-slate-200 hover:bg-slate-950 hover:text-white"
                      >
                        Register Demo
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="relative px-4 py-10 overflow-hidden bg-white md:px-20">
        <div className="mx-auto max-w-7xl">
          <div className="max-w-5xl mx-auto mb-12 text-center">
            <span className="inline-flex items-center gap-2 px-5 py-2 text-xs font-black tracking-widest text-purple-700 uppercase bg-purple-100 border border-purple-200 rounded-full shadow-sm">
              Practical Learning Advantage
            </span>

            <h2 className="mt-5 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
              Why Learn With{" "}
              <span className="text-blue-700">Practical Infosec?</span>
            </h2>

            <p className="max-w-4xl mx-auto mt-5 text-lg font-semibold leading-8 text-slate-600">
              We don’t just train you. We prepare you to be job-ready and
              project-ready with hands-on experience, real tools, structured
              guidance, and career-focused support.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {benefits.map((benefit) => (
              <div
                key={benefit.title}
                className="p-6 transition bg-white border shadow-lg group rounded-3xl border-slate-200 hover:-translate-y-2 hover:border-blue-300 hover:shadow-2xl"
              >
                <div className="flex items-center justify-center mb-5 text-3xl transition w-14 h-14 rounded-2xl bg-slate-100 group-hover:bg-blue-700 group-hover:text-white">
                  {benefit.iconImage ? (
                    <img
                      src={benefit.iconImage}
                      alt={benefit.title}
                      className="object-contain w-9 h-9"
                    />
                  ) : (
                    <span>{benefit.icon}</span>
                  )}
                </div>

                <h3 className="text-lg font-black text-slate-950">
                  {benefit.title}
                </h3>

                <p className="mt-3 text-sm font-semibold leading-6 text-slate-600">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CAREER PATH */}
      <section className="relative px-4 py-10 overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-slate-950 md:px-20">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.045)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.045)_1px,transparent_1px)] bg-[size:44px_44px] opacity-30"></div>

        <div className="relative z-10 mx-auto max-w-7xl">
          <div className="max-w-5xl mx-auto mb-12 text-center">
            <span className="inline-flex items-center px-5 py-2 text-xs font-black tracking-widest uppercase border rounded-full text-cyan-300 bg-white/10 border-white/15">
              From Beginner to Advanced Practitioner
            </span>

            <h2 className="mt-5 text-4xl font-black tracking-tight text-white md:text-5xl">
              Your Cybersecurity Career Roadmap
            </h2>

            <p className="max-w-4xl mx-auto mt-5 text-lg font-semibold leading-8 text-slate-300">
              Start with core VAPT fundamentals through the Junior program and
              progress into advanced API, Android, Thick Client, and real-world
              assessment workflows through the Senior program.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
            <div className="p-6 border shadow-2xl bg-white/10 border-white/15 rounded-3xl backdrop-blur">
              <p className="text-xs font-black tracking-widest uppercase text-cyan-300">
                Stage 01
              </p>
              <h3 className="mt-3 text-2xl font-black text-white">
                Build Fundamentals
              </h3>
              <p className="mt-3 text-sm font-semibold leading-6 text-slate-300">
                Learn networking, cybersecurity basics, OWASP, Burp Suite, Nmap,
                Metasploit, and web VAPT foundations.
              </p>
            </div>

            <div className="p-6 border shadow-2xl bg-white/10 border-white/15 rounded-3xl backdrop-blur">
              <p className="text-xs font-black tracking-widest uppercase text-amber-300">
                Stage 02
              </p>
              <h3 className="mt-3 text-2xl font-black text-white">
                Practice Real VAPT
              </h3>
              <p className="mt-3 text-sm font-semibold leading-6 text-slate-300">
                Work on labs, vulnerabilities, reporting, exploitation,
                remediation understanding, and interview-focused tasks.
              </p>
            </div>

            <div className="p-6 border shadow-2xl bg-white/10 border-white/15 rounded-3xl backdrop-blur">
              <p className="text-xs font-black tracking-widest text-red-300 uppercase">
                Stage 03
              </p>
              <h3 className="mt-3 text-2xl font-black text-white">
                Move Advanced
              </h3>
              <p className="mt-3 text-sm font-semibold leading-6 text-slate-300">
                Upgrade into API security, Android pentesting, Thick Client
                testing, CTFs, bug bounty workflows, and advanced assessments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOGS */}
      <section className="relative px-4 py-10 overflow-hidden bg-slate-50 md:px-20">
        <div className="mx-auto max-w-7xl">
          <div className="max-w-5xl mx-auto mb-12 text-center">
            <span className="inline-flex items-center gap-2 px-5 py-2 text-xs font-black tracking-widest text-blue-700 uppercase bg-blue-100 border border-blue-200 rounded-full shadow-sm">
              Security Knowledge Hub
            </span>

            <h2 className="mt-5 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
              Latest <span className="text-blue-700">Blogs</span>
            </h2>

            <p className="max-w-4xl mx-auto mt-5 text-lg font-semibold leading-8 text-slate-600">
              Stay ahead of evolving threats with technical walkthroughs,
              OWASP-focused explanations, and real-world security insights.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {blogCards.map((blog) => (
              <article
                key={blog.title}
                className="overflow-hidden transition bg-white border shadow-lg group rounded-3xl border-slate-200 hover:-translate-y-2 hover:shadow-2xl"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="object-cover w-full h-56 transition duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 to-transparent"></div>
                  <span className="absolute px-3 py-1 text-xs font-black text-white bg-blue-700 rounded-full left-4 bottom-4">
                    {blog.category}
                  </span>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-black leading-snug text-slate-950">
                    {blog.title}
                  </h3>

                  <p className="mt-3 text-sm font-semibold leading-6 text-slate-600">
                    {blog.description}
                  </p>

                  <div className="flex items-center justify-between pt-5 mt-5 text-sm font-bold border-t text-slate-500 border-slate-200">
                    <span>{blog.date}</span>
                    <span>{blog.readTime}</span>
                  </div>

                  <Link
                    to="/blog"
                    className="inline-flex items-center justify-center w-full px-5 py-3 mt-5 text-sm font-black text-white transition bg-slate-950 rounded-xl hover:bg-blue-700"
                  >
                    Read Blogs →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="px-4 py-10 bg-white md:px-20">
        <div className="relative max-w-6xl p-8 mx-auto overflow-hidden shadow-2xl rounded-[2rem] bg-gradient-to-r from-slate-950 via-blue-950 to-slate-950 md:p-10">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(14,165,233,0.25),transparent_35%)]"></div>

          <div className="relative z-10 grid items-center grid-cols-1 gap-8 lg:grid-cols-[1fr_auto]">
            <div>
              <p className="text-xs font-black tracking-widest uppercase text-cyan-300">
                Ready to Start?
              </p>

              <h2 className="mt-3 text-3xl font-black text-white md:text-4xl">
                Choose the right cybersecurity path and start learning with
                practical labs.
              </h2>

              <p className="mt-4 text-base font-semibold leading-7 text-slate-300">
                Not sure which course is right for you? Talk to our team and get
                guidance based on your current skill level and career goal.
              </p>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row lg:flex-col">
              <Link
                to="/junior-penetration-tester#demoRegistration"
                className="inline-flex items-center justify-center py-4 text-base font-black text-white transition px-7 rounded-2xl bg-gradient-to-r from-blue-700 to-cyan-500 hover:scale-105"
              >
                Apply for Junior
              </Link>

              <Link
                to="/senior-penetration-tester#demoRegistration"
                className="inline-flex items-center justify-center py-4 text-base font-black text-white transition px-7 rounded-2xl bg-gradient-to-r from-red-600 via-purple-700 to-blue-700 hover:scale-105"
              >
                Apply for Senior
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* SOCIAL MEDIA */}
<section className="relative px-4 py-12 overflow-hidden bg-white md:px-20">
  {/* Background Effects */}
  <div className="absolute top-0 right-0 rounded-full w-96 h-96 bg-blue-200/30 blur-3xl"></div>
  <div className="absolute bottom-0 left-0 rounded-full w-96 h-96 bg-cyan-200/20 blur-3xl"></div>

  <div className="relative z-10 max-w-6xl mx-auto text-center">
    <span className="inline-flex items-center gap-2 px-5 py-2 text-xs font-black tracking-widest text-blue-700 uppercase bg-blue-100 border border-blue-200 rounded-full shadow-sm">
      <span className="w-2 h-2 bg-blue-700 rounded-full animate-pulse"></span>
      Join Our Cybersecurity Community
    </span>

    <h2 className="mt-5 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
      Follow Practical{" "}
      <span className="text-blue-700">Infosec</span>
    </h2>

    <p className="max-w-3xl mx-auto mt-5 text-lg font-semibold leading-8 text-slate-600">
      Join our cybersecurity community for technical insights, career guidance,
      free workshops, bootcamps, live training updates, and practical VAPT
      learning content.
    </p>

    <div className="grid max-w-4xl grid-cols-2 gap-4 mx-auto mt-10 sm:grid-cols-4">
      <a
        href="https://x.com/Practicainfosec"
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center justify-center gap-3 p-6 transition bg-white border shadow-lg group rounded-3xl border-slate-200 hover:-translate-y-2 hover:border-sky-300 hover:shadow-2xl"
      >
        <div className="flex items-center justify-center w-16 h-16 text-3xl transition text-sky-500 rounded-2xl bg-sky-50 group-hover:scale-110">
          <i className="fab fa-twitter-square"></i>
        </div>

        <p className="text-sm font-black text-slate-800">X / Twitter</p>
      </a>

      <a
        href="https://www.linkedin.com/company/practicalinfosec"
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center justify-center gap-3 p-6 transition bg-white border shadow-lg group rounded-3xl border-slate-200 hover:-translate-y-2 hover:border-blue-300 hover:shadow-2xl"
      >
        <div className="flex items-center justify-center w-16 h-16 text-3xl text-blue-700 transition rounded-2xl bg-blue-50 group-hover:scale-110">
          <i className="fa-brands fa-linkedin"></i>
        </div>

        <p className="text-sm font-black text-slate-800">LinkedIn</p>
      </a>

      <a
        href="https://www.instagram.com/practicalinfosec/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center justify-center gap-3 p-6 transition bg-white border shadow-lg group rounded-3xl border-slate-200 hover:-translate-y-2 hover:border-pink-300 hover:shadow-2xl"
      >
        <div className="flex items-center justify-center w-16 h-16 text-3xl text-pink-600 transition rounded-2xl bg-pink-50 group-hover:scale-110">
          <i className="fa-brands fa-instagram"></i>
        </div>

        <p className="text-sm font-black text-slate-800">Instagram</p>
      </a>

      <a
        href="https://www.youtube.com/@PracticalInfosec-Telugu/videos"
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center justify-center gap-3 p-6 transition bg-white border shadow-lg group rounded-3xl border-slate-200 hover:-translate-y-2 hover:border-red-300 hover:shadow-2xl"
      >
        <div className="flex items-center justify-center w-16 h-16 text-3xl text-red-600 transition rounded-2xl bg-red-50 group-hover:scale-110">
          <i className="fa-brands fa-youtube"></i>
        </div>

        <p className="text-sm font-black text-slate-800">YouTube</p>
      </a>
    </div>
  </div>
</section>

{/* YOUTUBE VIDEO SECTION */}
<section className="relative px-4 py-10 overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-slate-950 md:px-20">
  {/* Background Pattern */}
  <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.045)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.045)_1px,transparent_1px)] bg-[size:44px_44px] opacity-30"></div>
  <div className="absolute top-0 left-0 rounded-full w-96 h-96 bg-red-500/20 blur-3xl"></div>
  <div className="absolute bottom-0 right-0 rounded-full w-96 h-96 bg-cyan-400/20 blur-3xl"></div>

  <div className="relative z-10 max-w-6xl mx-auto">
    <div className="max-w-4xl mx-auto mb-12 text-center">
      <span className="inline-flex items-center gap-2 px-5 py-2 text-xs font-black tracking-widest text-red-300 uppercase border rounded-full bg-white/10 border-white/15">
        <span className="w-2 h-2 bg-red-400 rounded-full animate-pulse"></span>
        Practical Infosec YouTube
      </span>

      <h2 className="mt-5 text-4xl font-black tracking-tight text-white md:text-5xl">
        Learn Cybersecurity From{" "}
        <span className="text-transparent bg-gradient-to-r from-red-300 via-cyan-300 to-blue-300 bg-clip-text">
          Real Videos
        </span>
      </h2>

      <p className="max-w-3xl mx-auto mt-5 text-lg font-semibold leading-8 text-slate-300">
        Stay ahead in cybersecurity with expert insights, practical tutorials,
        course previews, technical walkthroughs, and real-time discussions on
        application security, VAPT, and career growth.
      </p>
    </div>

    {/* Video Card */}
    <div className="relative max-w-5xl mx-auto">
      <div className="absolute -inset-4 bg-gradient-to-r from-red-500/30 via-blue-500/30 to-cyan-400/30 blur-2xl rounded-[2rem]"></div>

      <div className="relative overflow-hidden border shadow-2xl rounded-[2rem] bg-white/10 border-white/15 backdrop-blur">
        {/* Video Header */}
        <div className="flex flex-col gap-4 px-5 py-5 border-b bg-white/10 border-white/10 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-xs font-black tracking-widest text-red-300 uppercase">
              Featured Video
            </p>

            <h3 className="mt-1 text-xl font-black text-white">
              Practical Cybersecurity Training Preview
            </h3>
          </div>

          <a
            href="https://www.youtube.com/@PracticalInfosec-Telugu/videos"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 text-sm font-black text-white transition bg-red-600 rounded-xl hover:bg-red-700 hover:scale-105"
          >
            <i className="fa-brands fa-youtube"></i>
            Subscribe
          </a>
        </div>

        {/* Video */}
        <div className="p-3 sm:p-5">
          <div className="relative w-full overflow-hidden shadow-2xl aspect-video rounded-2xl bg-slate-950">
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/z92oqseWnV0"
              title="Practical Infosec Course Preview"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* Bottom Highlights */}
        <div className="grid grid-cols-1 gap-3 p-5 border-t sm:grid-cols-3 border-white/10 bg-white/5">
          <div className="p-4 text-center border rounded-2xl bg-white/10 border-white/10">
            <p className="text-sm font-black text-white">Course Previews</p>
          </div>

          <div className="p-4 text-center border rounded-2xl bg-white/10 border-white/10">
            <p className="text-sm font-black text-white">Technical Tutorials</p>
          </div>

          <div className="p-4 text-center border rounded-2xl bg-white/10 border-white/10">
            <p className="text-sm font-black text-white">Career Guidance</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

           {/* WHATSAPP STICKY BUTTON */}
<button
  type="button"
  onClick={toggleWhatsAppModal}
  className="fixed z-50 p-3 px-4 text-white transition -translate-y-1/2 rounded-full shadow-lg cursor-pointer top-1/2 right-6 bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:opacity-90 animate-pulse"
  aria-label="Join WhatsApp"
>
  <i className="text-4xl fa-brands fa-whatsapp"></i>
</button>

{/* WHATSAPP MODAL */}
{whatsappOpen && (
  <div
    className="fixed z-50 p-4 transition-opacity duration-300 -translate-y-1/2 bg-white shadow-xl top-1/2 right-20 rounded-xl w-72"
    role="dialog"
    aria-modal="true"
    aria-labelledby="whatsappTitle"
    onClick={(event) => event.stopPropagation()}
  >
    {/* Close Button */}
    <button
      type="button"
      onClick={toggleWhatsAppModal}
      className="absolute text-3xl text-gray-600 cursor-pointer top-2 left-4 hover:text-red-500"
      aria-label="Close"
    >
      &times;
    </button>

    <h2
      id="whatsappTitle"
      className="mt-6 mb-2 text-lg font-bold text-center text-gray-800"
    >
      Unsure about which course to choose?
    </h2>

    <p className="mb-3 text-sm text-center text-gray-700">
      Tap below to start a WhatsApp chat — we're here to help!
    </p>

    <div className="flex flex-col items-center gap-3">
      <button
        type="button"
        onClick={openWhatsAppChat}
        className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-white transition bg-green-600 rounded-full hover:bg-green-700"
        aria-label="Chat Now on WhatsApp"
      >
        <i className="fa-brands fa-whatsapp"></i>
        Chat Now
      </button>

      <button
        type="button"
        onClick={openWhatsAppAppFallback}
        className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-gray-800 transition border border-gray-200 rounded-full hover:bg-gray-50"
        aria-label="Open in WhatsApp App"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4 text-green-600"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M20.52 3.48A11.93 11.93 0 0012 .5C5.73.5.99 5.24.99 11.5c0 2.01.53 3.95 1.53 5.68L0 24l6.97-1.79c1.61.45 3.28.68 4.9.68 6.27 0 11.01-4.74 11.01-11 0-3.02-1.18-5.85-3.36-7.41zM12 21.5c-1.44 0-2.86-.34-4.14-.99l-.3-.15-4.14 1.06 1.15-3.98-.18-.31A8.12 8.12 0 013 11.5c0-4.97 4.06-9 9-9 2.41 0 4.66.94 6.36 2.64a8.95 8.95 0 012.64 6.36c0 4.97-4.06 9-9 9z" />
        </svg>
        Open in App
      </button>
    </div>
  </div>
)}

{/* FLOATING CALL BUTTON */}
<a
  href="tel:+91-9080432374"
  className="fixed z-50 p-3 text-white transition rounded-md shadow-lg cursor-pointer bg-violet-600 bottom-60 right-7 hover:bg-green-700"
  aria-label="Call Us"
>
  <i className="text-2xl fa-solid fa-phone"></i>
</a>

{/* BACK TO TOP BUTTON */}
{showBackToTop && (
  <button
    type="button"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    className="fixed z-50 p-4 text-white transition bg-blue-700 rounded-lg shadow-lg cursor-pointer bottom-12 right-7 hover:bg-blue-800"
    aria-label="Back to top"
  >
    <i className="text-xl fa-solid fa-arrow-up"></i>
  </button>
)}
    </main>
  );
}

export default Home;